import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class TenantFeatureService extends BaseService {
  constructor() {
    super(constants.GET_TENANT_FEATURE_DATA, 'tenantFeatureServiceStatus');
  }

  handleEvent(eventName, event) {
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    return this.getClient('evergreen').get(`/aiadmin/tenant/feature`, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('tenantFeatureModel').setResponse(response);
    const notification = {
      open: true,
      type: 'success',
      message: 'Data Fetched successfully'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: 'Error in Retreiving Features',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
